export { ScheduleComponent } from './v1/schedule.component';
export { ScheduleModule } from './schedule.module';
